import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ShowreelSection from './components/ShowreelSection';
import WhatWeBuildSection from './components/WhatWeBuildSection';
import HowItWorksSection from './components/HowItWorksSection';
import TechnologySection from './components/TechnologySection';
import VisionSection from './components/VisionSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ShowreelSection />
        <WhatWeBuildSection />
        <HowItWorksSection />
        <TechnologySection />
        <VisionSection />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
